import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import DashboardItem from "./DashboardItem";
import { privateApi } from "../../api";
import { BiMessageSquareError } from "react-icons/bi";
import { FaUsers, FaBlog, FaRegUser } from "react-icons/fa";
import { MdOutlineStorefront } from "react-icons/md";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { RiChatNewLine, RiGalleryFill } from "react-icons/ri";

const Dashboard = () => {
      const [orders, setOrders] = useState([]);
      const [loading, setLoading] = useState(false);
      const [totalUsers, setTotalUsers] = useState(0);
      const [totalProducts, setTotalProducts] = useState(0);
      const [totalBlogs, setTotalBlogs] = useState(0);
      const [totalProductEnquiry, setTotalProductEnquiry] = useState(0);
      const [totalBanners, setTotalBanners] = useState(0);
      const [totalTestimonials, setTotalTestimonials] = useState(0);
      const [totalContactRequests, setTotalContactRequests] = useState(0);
      const [totalCandidates, setTotalCandidates] = useState(0);

      const loadData = async () => {
            setLoading(true);

            await privateApi
                  .get(`/dashboard`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setOrders(response.data.orders);
                              setTotalUsers(response.data.totalUsers);
                              setTotalProductEnquiry(
                                    response.data.totalProductEnquiry
                              );
                              setTotalProducts(response.data.totalProducts);
                              setTotalBlogs(response.data.totalBlogs);
                              setTotalBanners(response.data.totalBanners);
                              setTotalCandidates(response.data.totalCandidates);
                              setTotalContactRequests(
                                    response.data.totalContactRequests
                              );
                              setTotalTestimonials(
                                    response.data.totalTestimonials
                              );
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });

            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      return (
            <>
                  <Row className="g-3">
                        <DashboardItem
                              title="Total Products"
                              total={totalProducts}
                              link="/dashboard/products"
                              icon={<MdOutlineStorefront />}
                        />

                        <DashboardItem
                              title="Total Banner"
                              total={totalBanners}
                              link="/dashboard/banners"
                              icon={<RiGalleryFill />}
                        />
                        <DashboardItem
                              title="Total Testimonials"
                              total={totalTestimonials}
                              link="/dashboard/testimonials"
                              icon={<IoChatboxEllipsesOutline />}
                        />
                        <DashboardItem
                              title="Total Blogs"
                              total={totalBlogs}
                              link="/dashboard/blogs"
                              icon={<FaBlog />}
                        />
                        <DashboardItem
                              title="Total Product Enquiry"
                              total={totalProductEnquiry}
                              link="/dashboard/product_enquiries"
                              icon={<RiChatNewLine />}
                        />
                        <DashboardItem
                              title="Total Contact Request"
                              total={totalContactRequests}
                              link="/dashboard/contact/requests"
                              icon={<BiMessageSquareError />}
                        />
                        <DashboardItem
                              title="Total Candidates"
                              total={totalCandidates}
                              link="/dashboard/candidates"
                              icon={<FaUsers />}
                        />
                        <DashboardItem
                              title="Total Users"
                              total={totalUsers}
                              link="/dashboard/users"
                              icon={<FaRegUser />}
                        />
                  </Row>
            </>
      );
};

export default Dashboard;
